import React, { useContext } from "react"
import Icon from "@kit/design/icon"
import VisuallyHidden from "@kit/design/visually-hidden"
import { DiscoveryHubContext } from "./discovery-hub-context"
import { Menu, MenuButton } from "@reach/menu-button"
import pluralize from "pluralize"

export default function Button({ toggleDrawer }) {
  const context = useContext(DiscoveryHubContext)

  const buttonClass = `
    main-link
    cursor-pointer
    p-1
    focus:bg-blue-600
    focus:bg-warm-white-200
    focus:no-underline
    focus:outline-none
    h-full
    hover:no-underline
    text-black
    items-center
    nav-hover
    relative
    rounded
  `

  const handleClick = event => {
    switch (event.keyCode) {
      case 13:
        event.preventDefault()
        toggleDrawer()
        break
      case 32:
        event.preventDefault()
        toggleDrawer()
        break
    }
  }

  return (
    <Menu>
      <MenuButton
        onKeyDown={handleClick}
        onMouseDown={toggleDrawer}
        className={buttonClass}
      >
        <VisuallyHidden>App Notifications</VisuallyHidden>
        {context.notificationCounter > 0 && (
          <div
            className="inline-flex absolute -top-2 -right-2 justify-center items-center pl-1 pr-1 h-5 text-xs text-gray-900 bg-green-500 rounded-full break-normal"
            style={{ top: "-7px", left: "14px", minWidth: "1.25rem" }}
          >
            {context.notificationCounter}
            <VisuallyHidden>
              {" "}
              unread app{" "}
              {pluralize("notification", context.notificationCounter)}
            </VisuallyHidden>
          </div>
        )}
        <Icon name="alarm" />
      </MenuButton>
    </Menu>
  )
}
